module.exports = __webpack_public_path__ + "img/close-fat.5217c7b7.svg";